import React from 'react';
import get from 'lodash/get';
import { Box } from '@lightspeed/cirrus-core';
import { Button } from '@lightspeed/flame/Button';
import { Divider } from '@lightspeed/flame/Divider';
import Group from '@lightspeed/cirrus-group';
import { IconChevronLeft } from '@lightspeed/flame/Icon/ChevronLeft';
import Modal, { ModalHeader, ModalBody, ModalFooter } from '@lightspeed/cirrus-modal';
import Text from '@lightspeed/cirrus-text';
import { getL10nForCountryCode } from 'cirrus/Dropdown/Country/utils';
import { sendAgeVerificationRequest, errorReasons } from '../utils';
import { modalSteps } from '..';

const AgeVerificationConfirm = ({ setStep, setStepWithData, stepData = {}, reject, resolve }) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const countryCode = get(window.merchantos, 'locale.country_code');
  const { translations } = getL10nForCountryCode(countryCode, ['translations.zip']);

  const { name, dateOfBirth, cardExpiry, documentNumber, postalCode } = stepData;

  return (
    <Modal className="cirrus responsive" isOpen onRequestClose={reject}>
      <ModalHeader onCloseClicked={reject}>Check customer ID</ModalHeader>
      <ModalBody>
        <Box mb={1}>
          <Text>Does the customer ID match the information below?</Text>
        </Box>
        <Divider className="cr-pv-2" />
        {name ? (
          <Group className="cr-justify-between">
            <Text bodyLarge>Name</Text>
            <Text bodyLarge bold className="notranslate">
              {name}
            </Text>
          </Group>
        ) : null}
        <Divider className="cr-pv-2" />
        {dateOfBirth ? (
          <Group className="cr-justify-between">
            <Text bodyLarge>Date of birth</Text>
            <Text bodyLarge bold className="notranslate">
              {dateOfBirth}
            </Text>
          </Group>
        ) : null}
        <Divider className="cr-pv-2" />
        {cardExpiry ? (
          <Group className="cr-justify-between">
            <Text bodyLarge>Expires</Text>
            <Text bodyLarge bold className="notranslate">
              {cardExpiry}
            </Text>
          </Group>
        ) : null}

        {documentNumber ? (
          <>
            <Divider className="cr-pv-2" />
            <Group className="cr-justify-between">
              <Text bodyLarge>ID Number</Text>
              <Text bodyLarge bold className="notranslate">
                {documentNumber}
              </Text>
            </Group>
          </>
        ) : null}
        {!documentNumber && postalCode ? (
          <>
            <Divider className="cr-pv-2" />
            <Group className="cr-justify-between">
              <Text bodyLarge>{translations.zip}</Text>
              <Text bodyLarge bold className="notranslate">
                {postalCode}
              </Text>
            </Group>
          </>
        ) : null}
      </ModalBody>
      <ModalFooter>
        <Group className="cr-justify-between">
          <Button onClick={() => setStep(modalSteps.AGE_VERIFICATION)}>
            <IconChevronLeft />
            Back
          </Button>
          <Group className="cr-justify-end">
            <Button
              onClick={() =>
                setStepWithData({
                  step: modalSteps.AGE_VERIFICATION_ERROR,
                  data: {
                    reason: errorReasons.AGE,
                  },
                })
              }
            >
              No, ID doesn&apos;t match
            </Button>
            <Button
              variant="primary"
              fill
              loading={isLoading}
              onClick={() => {
                setIsLoading(true);
                sendAgeVerificationRequest({
                  resolve,
                  reject,
                  setStepWithData,
                  stepData,
                });
              }}
            >
              Yes, ID matches
            </Button>
          </Group>
        </Group>
      </ModalFooter>
    </Modal>
  );
};

export default AgeVerificationConfirm;
